<template>
  <router-link to="/" aria-label="home"><img src="/logo.svg" class="img-fluid"/></router-link>
</template>

<script>
export default {
  name: 'HomeLink',
};
</script>
